import { lazyWrap } from '@neptune/shared/common-ui';

export const LazyReportWidgetEmbedContainer = lazyWrap(
  async () =>
    (await import(/* webpackChunkName: "reports" */ '@neptune/reports-feature'))
      .ReportWidgetEmbedContainer,
);
